export default __webpack_public_path__ + "static/media/test3-slots.6dbbe620.png";